<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main">
        <SubTitleComponent :title="title"></SubTitleComponent>
        <div class="box">
          <el-form ref="form" :model="form" label-width="120px" label-position="top">
            <el-form-item label="客户名称">
              <el-input v-model="form.name" placeholder="请输入客户公司名称"></el-input>
            </el-form-item>
            <el-form-item label="地区">
              <el-cascader
                v-model="form.selectedOptions"
                :options="cityData"
                :props="{ expandTrigger: 'hover' }"
                @change="handleChange"
                placeholder="请选择省/市/区">
              </el-cascader>
            </el-form-item>
            <el-form-item label="行业类型">
              <el-select v-if="industryData.length > 0" v-model="form.industry" placeholder="请选择行业类型">
                <!-- <el-option label="互联网" value="互联网"></el-option>
                <el-option label="国企/事业单位" value="国企/事业单位"></el-option>
                <el-option label="医疗" value="医疗"></el-option> -->
                <el-option v-for="(item,index) in industryData" :key="'industry' + index" :label="item.industry_type" :value="item.industry_type"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目类型">
              <el-radio-group v-if="projectData.length > 0" v-model="form.type">
                <!-- <el-radio label="总部大楼"></el-radio>
                <el-radio label="空间平层"></el-radio> -->
                <el-radio v-for="(item,index) in projectData" :key="'project' + index" :label="item.project_type" :value="item.project_type"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="项目面积（m²）">
              <el-input v-model="form.square" placeholder="请输入项目面积"></el-input>
            </el-form-item>
            <el-form-item label="项目联系人">
              <el-input v-model="form.contact_neme" placeholder="请输入项目联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input v-model="form.contact_phone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>
import cityData from '@/utils/city.json';

console.log(cityData)

let _ajaxType = 0

export default {
  name: 'CustomerNew',
  components: {},
  data() {
    return {
      title: '创建新客户',
      form: {
        id: '',
        name: '',
        industry: '',
        type: '',
        square: '',
        province: '',
        city: '',
        area: '',
        selectedOptions: [],
        contact_phone: '',
        contact_neme: ''
      },
      cityData: cityData,
      industryData: [],
      projectData: []
    }
  },
  mounted() {
    this.getDeploy()
    let _info = JSON.parse(localStorage.getItem('customerInfo'))
    console.log('new', _info)
    if(_info){
      this.form.id = _info.client_id
      this.form.name = _info.client_name
      this.form.industry = _info.industry_type
      this.form.type = _info.project_type
      this.form.square = _info.project_area
      this.form.province = _info.province_name
      this.form.city = _info.city_name
      this.form.area = _info.area_name
      this.form.contact_neme = _info.contact_neme
      this.form.contact_phone = _info.contact_phone
      this.form.selectedOptions = [String(_info.province_id), String(_info.city_id), String(_info.region_id)]
      console.log('new2', _info, this.form)
      localStorage.removeItem('customerInfo')
    }
  },
  methods: {
    handleDetal(index, row) {
      console.log(index, row);
    },
    getDeploy() {
      let _url = "/api/?mod=deploy"
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("styleData", _data);
        if (json.data.errcode == 0) {
          this.industryData = _data.industry
          this.projectData = _data.project
        }
        console.log(json.data);
      })
    },
    onSubmit() {
      console.log('submit!');
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=client&action=save"
      let _clientData = {
        client_name: this.form.name,
        province_id: this.form.selectedOptions[0],
        city_id: this.form.selectedOptions[1],
        region_id: this.form.selectedOptions[2],
        industry_type: this.form.industry,
        project_type: this.form.type,
        project_area: this.form.square,
        contact_phone: this.form.contact_phone,
        contact_neme: this.form.contact_neme
      }
      let _id = this.form.id
      if(_id != ''){
        _clientData['client_id'] = _id
      }
      console.log(_clientData)
      this.axios.post(_url, _clientData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("clientData", _data);
        if (json.data.errcode == 0) {
          let _this = this
          let _message = '新建客户成功'
          if(_id != ''){
            _message = '编辑客户信息成功'
          }
          this.$message({
            message: _message,
            type: 'success',
            offset: 300,
            onClose: function() {
              _this.$router.replace('/')
            }
          });
        }
        console.log(json.data);
      })
    },
    handleChange(value) {
      // this.selectedOptions = value;
      console.log(value)
      console.log(this.form)
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .el-input__inner {
      width: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Customer/New.vue